
















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Sections
---------------------------------------- */

import Footer from '@layout/Footer.vue';
import Navigation from '@layout/Navigation.vue';

/** ----------------------------------------
    JS Modules
 ---------------------------------------- */

import { createCircle } from '@js/module/Circle';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        Footer,
        Navigation
    },

    mounted() {
        const circles = document.querySelectorAll('.circle');

        [...circles].forEach(() => {
            createCircle('Digital, Strategy & Design', {
                class: '.circle__radial',
                parent: '.circle'
            });
        });
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Master extends Vue {}

